import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { FormValidation } from '../../libs/ruvpp-angular2-comun/FormValidation';
import { OutputConsultaUsuario, Usuario, JsonResponse } from '../../modelo';
import { ServicioIndicadorCarga } from './../../libs/ruvpp-angular2-comun/indicador-carga';
import { SimuladorService } from './../../datos/simulador.service';
import { ServicioAlertas } from './../../libs/ruvpp-angular2-comun/ServicioAlertas';
import { HttpSession } from 'src/app/libs/ruvpp-angular2-comun/HttpSession';
import { Router } from '@angular/router';
import { MenuComponent } from '../menu/menu.component';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    //styleUrls: ['../../../assets/css/styles.css', '../../../assets/css/bootstrap.css']
})
export class LoginComponent implements OnInit {

    public entity: Usuario;
    public user_MensajeError: FormValidation = new FormValidation(null);
    public password_MensajeError: FormValidation = new FormValidation(null);
    public PATH: string = '../assets/images';
    public menu: MenuComponent;

    /**
     * 
     * @param servicioIndicadorCarga
     * @param servicioAlertas
     * @param service
     * @param _router
     */
    constructor(private servicioIndicadorCarga: ServicioIndicadorCarga, private servicioAlertas: ServicioAlertas, private service: SimuladorService, private _router: Router) {
        this.menu = new MenuComponent(_router);
    }

    ngOnInit(): void {
        //this.entity = <Usuario>{ user: 'IEAAAA30', password: 'Prueba99' };
        this.entity = <Usuario>{ user: '', password: '' };
    }

    public autentificar(): void {

        if (!this.validarFormumlario()) {

            this.servicioIndicadorCarga.mostrar('Verificando informaci�n ...');

            // this.menu.PortadaSimuladorAdmin();

            this.service.Autentificacion(this.entity).subscribe((resultado: JsonResponse<OutputConsultaUsuario>) => {

                if (resultado != null && resultado.code == 200) {

                    if (resultado.model.acceso == true) {

                        let result = resultado.model;

                        HttpSession.setAttribute('USER', result);

                        HttpSession.setAttribute('USER_NAME', `${result.nombre} ${result.paterno} ${result.materno}`.toUpperCase());

                        this.menu.PortadaSimuladorAdmin();

                    } else {

                        this.servicioAlertas.mostrarConOpciones({
                            title: "Simulador",
                            text: `Usuario o password incorrecto.`,
                            icon: "warning",
                            showCancelButton: false,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Aceptar',
                            cancelButtonText: 'Cancelar'
                        }).then((result) => {

                            console.log('result.value -->> ', result.value)

                            if (result.value) {
                                console.log('true')
                            } else {

                                if (result.dismiss === Swal.DismissReason.cancel) {
                                    console.log('false')
                                }
                            }

                        })

                    }

                } else {

                    this.servicioAlertas.mostrarConOpciones({
                        title: "Simulador",
                        text: `Error al ejecutar Web Service...`,
                        icon: "error",
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: 'Cancelar'
                    }).then((result) => {

                        console.log('result.value -->> ', result.value)

                        if (result.value) {
                            console.log('true')
                        } else {

                            if (result.dismiss === Swal.DismissReason.cancel) {
                                console.log('false')
                            }
                        }

                    })
                }

            });

        }

    }

    /**
    * 
    * 
    */
    public validarFormumlario(): boolean {

        var error = false;

        this.user_MensajeError = new FormValidation(this.entity.user).requered('El Usuario es obligatorio.');

        if (this.user_MensajeError.error) {
            error = true;
        }

        this.password_MensajeError = new FormValidation(this.entity.password).requered('El Password es obligatorio.');

        if (this.password_MensajeError.error) {
            error = true;
        }

        return error;
    }

    /**
     * 
     * @param tipo
     */
    public actualizarErrores(tipo: string) {

        switch (tipo) {

            case 'user':

                this.user_MensajeError = new FormValidation(this.entity.user).requered('El Usuario es obligatorio.');

                break;

            case 'password':

                this.password_MensajeError = new FormValidation(this.entity.password).requered('El Password es obligatorio.');

                break;
        }
    }

}
